import React from "react";
import { Box, Icon, Text } from "../elements";

export const NoPermission = () => {
  return (
    <Box className="mc-blank">
      <Icon type="error_outline" />
      <Text>Sorry you have no permission !!!</Text>
    </Box>
  );
};
